import moment from 'moment-timezone';
import getTimezone from '../../scripts/get-timezone';
import getTimezoneNames from '../../scripts/get-timezone-names'
import supportedSensorDisplayDatapoints from '../../util/supported-sensor-display-datapoints'
import defaultSensorDisplayDatapoints from '../../util/default-sensor-display-datapoints'
import SiteMessagesInstance from '../../components/site-messages'

class AccountDisplayPreferences {

  constructor (container) {

    if(container) {

      this.container = container;

      this.render();

      this.currentTimezone = this.container.querySelector('.account-display-preferences__device-time-zone');
      this.useLocalTimezoneToggle = this.container.querySelector('input[name="use_local_timezone"]');
      this.timezoneSelectContainer = this.container.querySelector('.account-display-preferences__timezone-select');
      this.timezoneSelect = this.timezoneSelectContainer.querySelector('select[name="timezone"]');

      this.$sensor_display_checkboxes = $(this.container).find('input[type="checkbox"][data-for="sensor_display_datapoint"]');

    }

  }

  init() {

    this.maybeToggleTimezone();
    this.useLocalTimezoneToggle.addEventListener('change', this.maybeToggleTimezone.bind(this));
    this.bindActions();

  }

  bindActions() {

    this.$sensor_display_checkboxes.on('change', () => {

      const datapoints = [];

      this.$sensor_display_checkboxes.each((i, checkbox) => {

        if($(checkbox).is(":checked")) {
          datapoints.push($(checkbox).val());
        }

      });

      apiRequest("post", "/user/sensor_display_datapoints", {
        datapoints: datapoints,
      }).then(r => {
        if(r.type === 'error') {
          SiteMessagesInstance.addMessage("error", r.message);
          SiteMessagesInstance.displayMessages(true);
        }
      });

    });

  }

  maybeToggleTimezone() {

    if($(this.useLocalTimezoneToggle).is(':checked')) {

      $(this.timezoneSelect).attr('disabled', true);
      this.timezoneSelectContainer.classList.remove('is-active');

      try {

        if (moment.tz && moment.tz.guess()) {

          const localTimezone = moment.tz.guess();
          const timezone = getTimezone(localTimezone);

          if (timezone) {
            this.currentTimezone.innerHTML = `(${timezone.alternativeName})`;
          }

        }

      } catch (e) {
        this.currentTimezone.innerHTML = '';
      }

    } else {

      $(this.timezoneSelect).removeAttr('disabled');
      this.timezoneSelectContainer.classList.add('is-active');

      this.currentTimezone.innerHTML = '';

    }

  }

  render() {

    const timezones = getTimezoneNames();
    const sensorDisplayDatapoints = supportedSensorDisplayDatapoints

    const selectedSensorDisplayDatapoints =
      (window.currentUser && window.currentUser.sensor_display_datapoints) ?
        window.currentUser.sensor_display_datapoints : defaultSensorDisplayDatapoints

    let html = `
    <div class="grid-x grid-margin-x">
      <div class="cell medium-6 small-order-2 medium-order-1">

        <div class="account-display-preferences__preference" data-for="temp_pref">

          <label for="temp_pref">Temp Scale</label>
          <select name="temp_pref">
            <option value="C">Celsius</option>
            <option value="F">Fahrenheit</option>
          </select>

        </div>
        
        <div class="account-display-preferences__preference" data-for="temp_pref_digits">

          <label for="temp_pref">Decimal Precision</label>
          <select name="temp_pref_digits">
            <option value="auto">Auto</option>
            <option value="1">One (0.1)</option>
            <option value="2">Two (0.01)</option>
          </select>

        </div>

        <div class="account-display-preferences__preference" data-for="chart_fill">

          <label for="chart_fill">Chart Auto Scaling</label>

          <div class="switch medium">
            <input class="switch-input" type="checkbox" id="chart_fill"
                   name="chart_fill" value="1"/>
            <label class="switch-paddle" for="chart_fill">
              <span class="switch-active">On</span>
              <span class="switch-inactive">Off</span>
            </label>
          </div>

          <p class="text--small" style="margin-top: 15px;">When ON, the graphs automatically scale to match the high and low
            points currently in the chart.</p>
        </div>

      </div>
      <div class="cell medium-6 small-order-1 medium-order-2">
        <div class="account-display-preferences__preference" data-for="timezone">

          <div class="account-display-preferences__use-local-timezone">

            <label for="use_local_timezone">
              Set Timezone Automatically
              <span class="account-display-preferences__device-time-zone"></span>
            </label>

            <div class="switch medium">
              <input class="switch-input" type="checkbox" id="use_local_timezone"
                     name="use_local_timezone" value="1"/>
              <label class="switch-paddle" for="use_local_timezone">
                <span class="switch-active">On</span>
                <span class="switch-inactive">Off</span>
              </label>
            </div>

          </div>

          <div class="account-display-preferences__timezone-select">

            <label for="timezone">Timezone</label>
            <select name="timezone">
              ${timezones.map(timezone => `<option value="${timezone[0]}">${timezone[1]}</option>`).join("\n")}
            </select>

          </div>

        </div>
      </div>
    </div>
    
    <div class="divider"></div>
    
    <h4 class="heading heading--smaller">Dashboard | My Sensors</h4>
    <p>Select which data points (if supported by your sensor) to show on the dashboard</p>
    
    ${sensorDisplayDatapoints.map(datapoint => {
      return `
      <label class="account-display-preferences__include">
        <div class="account-display-preferences__include__checkbox">
          <input type="checkbox" value="${datapoint.id}" data-for="sensor_display_datapoint" name="sensor_display_datapoints[]"
           ${selectedSensorDisplayDatapoints.includes(datapoint.id) ? 'checked' : ''}
           />
        </div>
        <div class="account-display-preferences__include__label">${datapoint.name}</div>
      </label>
      `
    }).join('')}
    
    `;

    this.container.innerHTML = html;


  }

}

export default AccountDisplayPreferences;
